import { getWithParamsRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

interface QueryParamsForAccounts {
  sharedBilling?: boolean;
}

export async function getAccounts(
  queryParams: QueryParamsForAccounts,
  signal?: AbortSignal
): Promise<ApiResponse<{ accounts: Account[] }>> {
  return getWithParamsRequest('accounts', queryParams, signal);
}
